import { useContext } from 'react';

import { CurrentAccountFragment } from '../api/graphqlApi';
import {
  AccountContext,
  AccountContextValue
} from '../providers/AccountProvider';

export const useAccountContext = (): Exclude<
  AccountContextValue,
  undefined
> => {
  const context = useContext(AccountContext);
  if (!context) {
    throw new Error('useAccountContext requires AccountProvider');
  }
  return context;
};

export const useCurrentAccount = (): CurrentAccountFragment => {
  const { account } = useAccountContext();
  if (account) {
    return account;
  }

  throw new Error(
    'Current account does not exist. Consider useCurrentAccountOptional or wrap component in a RequireAccountRoute.'
  );
};
